import React, { useState, useEffect, Fragment, useRef } from "react";
import useRequireAuth from "../../utils/useRequireAuth";
import { useDispatch } from "react-redux";
import { getCommonDataBasedOnId, saveData } from "../store/customer/CustomerSocialAddUpdateFunction";
import { CREATE_PODS } from "../../utils/constants";
import { ReactComponent as CloseModalImg } from "../../assets/images/closeModalImg.svg";
import { ReactComponent as DownArrow } from "../../assets/images/downArrow.svg";
import { pushAlert } from "../../utils/alertSlice";
import { Dialog } from "@mui/material";
import { getSentenceCase } from "../../utils/utilityFunctions/stringUtility";
const AddNewPodModal = ({ open, onClose, category_id, refetchPods, customerId }) => {
  const token = useRequireAuth();

  const dispatch = useDispatch();
  const companyLocalData = localStorage.getItem("company_data");
  const parsedCompanyData = JSON.parse(companyLocalData);

  const [errors, setErrors] = useState({});
  const [show, setShow] = useState("");

  const [formData, setFormData] = useState({
    pod_name: "",
  });

  const handleFieldChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  };

  const validate = () => {
    let tempErrors = {};

    if (!formData?.pod_name) {
      tempErrors.pod_name = "Pod is Required";
    }
    if (!customerId) {
      dispatch(pushAlert({ type: "danger", message: "Please select a customer", visible: true }));
      tempErrors.customer_id = "Customer id is Required";
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors)?.length;
  };

  const handleSave = async (e) => {
    e.preventDefault();
    if (validate()) {
      return false;
    }
    const customerData = {
      ...formData,
      customer_id: customerId,
      company_id: parsedCompanyData.company_id,
      is_type_project: category_id === "project",
      description: "",
    };

    const response = await saveData(CREATE_PODS, [customerData], token?.token);
    if (response?.success) {
      dispatch(pushAlert({ type: "success", message: "Business Caterory Added Successfully", visible: true }));
      refetchPods();
      onClose();
    } else {
      setShow(response?.message);
      refetchPods();
      dispatch(pushAlert({ type: "danger", message: `${response?.message}`, visible: true }));
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <div className="relative  py-2 mt-18 bg-white border border-E5ECF0 font-popns drop-shadow-lg  rounded-md w-500px overflow-hidden no-scrollbar ">
        <div className=" flex items-center justify-between  pr-3 pl-2 pb-2 border-BECBD3 rounded-t">
          <div className="px-2"></div>
          <br />
          <h3 className="text-16 font-500 text-434852">
            {" "}
            Add {["project", "deal"].includes(category_id?.toLowerCase()) ? getSentenceCase(category_id) : "Task"} Pod
          </h3>

          <button
            onClick={onClose}
            type="button"
            className="text-454545 bg-transparent hover:bg-F1F5F8 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
            data-modal-hide="assets-modal"
          >
            {/* <svg
                className="w-3 h-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                />
              </svg> */}
            <CloseModalImg className="w-3 h-3" />
            <span className="sr-only">Close modal</span>
          </button>
        </div>

        <form onSubmit={handleSave} className="w-full lg:max-h-[70vh]  overflow-x-hidden  no-scrollbar">
          <div className="basis-5/5 mb-3 px-6 ">
            <label htmlFor="first_name" className="block text-lg border-t pt-2">
              <span className="text-sm  text-434852 font-400">
                Enter New{" "}
                {["project", "deal"].includes(category_id?.toLowerCase()) ? getSentenceCase(category_id) : "Task"}
                {""}Pod
              </span>
              <span className=" text-red-500"> *</span>
              {errors.pod_name && <span className="text-red-700 text-12 ">{errors.pod_name}</span>}
            </label>
            <input
              type="text"
              name="pod_name"
              onChange={handleFieldChange}
              value={formData["pod_name"]}
              className="w-full rounded-md border-gray-300"
              placeholder="Enter New Pod"
            />
            {show && <span className="text-red-700">{show}</span>}
          </div>

          <div className="flex justify-end pb-1 text-md w-full">
            <div className="px-6">
              <button
                onClick={onClose}
                type="button"
                className="w-28 text-535252 bg-F4F4F4 hover:bg-eeeeee cancel-btn focus:ring-4 focus:ring-blue-300 font-semibold px-5 py-1 text-center rounded-[5px]"
              >
                CANCEL
              </button>

              <button
                type="submit"
                className="w-28 text-white bg-1D4469 hover:bg-20486F save-btn font-semibold  border border-gray-200 py-1 px-5 ms-3 rounded-[5px]"
              >
                ADD
              </button>
            </div>
          </div>
        </form>
      </div>
    </Dialog>
  );
};

export default AddNewPodModal;
